<template>
    <oss-dialog
        v-model="dialog"
        @valid="createManualUserActivity"
        :validLoading="loading"
        :validDisabled="validDisabled"
        :title="'Suivi des temps'"
    >
        <!-- <v-card class="uploadDocument">
        <v-toolbar  color="primary" elevation="0">
            <v-toolbar-title>Suivi des temps</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="close()">
                <v-icon>$close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-container fluid grid-list-md> -->

        <v-row no-gutters :style="{ width: $vuetify.display.mobile ? 'auto' : '800px' }">
            <v-col cols="12" class="d-flex justify-end pb-5">
                <v-btn-toggle
                    v-model="windowStep"
                    rounded="xl"
                    variant="outlined"
                    density="compact"
                    color="primary"
                    base-color="whitesmoke"
                >
                    <!-- <template #default="{isSelected}">
                        <v-btn-icon rounded="0" variant="outlined" :color="isSelected(0) ? 'primary' : ''" size="small" :value="'form'" icon="$fa-user-edit"> {{ isSelected(0) ? 'primary' : 'dd' }} </v-btn-icon>
                        <v-btn-icon rounded="0" variant="outlined" :color="isSelected(1) ? 'primary' : ''" size="small" :value="'table'" icon="$fa-history"> </v-btn-icon>
                    </template> -->
                    <v-btn :value="'form'">
                        <v-icon icon="$fa-user-edit"></v-icon>
                    </v-btn>
                    <v-btn :value="'table'">
                        <v-icon icon="$fa-history"></v-icon>
                    </v-btn>
                </v-btn-toggle>
            </v-col>
            <v-col cols="12">
                <v-window v-model="windowStep">
                    <v-window-item :value="'form'">
                        <v-form v-model="valid">
                            <v-row no-gutters class="d-flex justify-center align-center pb-4">
                                <v-col cols="12" class="d-flex pa-1">
                                    <ossCompanySelector
                                        v-model="company"
                                        :items="allAvailableCompanies"
                                        :selectClass="'oss-dark'"
                                        :chipMaxLength="9"
                                    />
                                </v-col>
                                <v-col cols="8" class="pa-1">
                                    <ossAccountingPeriodSelector
                                        v-model="accountingPeriod"
                                        :global="false"
                                        :companyId="company.id"
                                        :disabled="!company.id"
                                        dense
                                        block
                                        :selectClass="'oss-dark'"
                                    />
                                </v-col>
                                <v-col cols="4" class="d-flex pa-1">
                                    <ossDatePickerFilled
                                        v-model="date"
                                        :label="'Date'"
                                        :textFieldReadOnly="false"
                                        hide-details
                                        class="w-100"
                                    />
                                </v-col>
                                <v-col cols="4" class="pa-1">
                                    <v-text-field-filled
                                        v-model.number="duration.hours"
                                        :label="'Nombre d\'heures'"
                                        density="compact"
                                    />
                                </v-col>
                                <v-col cols="4" class="pa-1">
                                    <v-text-field-filled
                                        v-model.number="duration.minutes"
                                        :label="'Nombre de minutes'"
                                        density="compact"
                                    />
                                </v-col>
                                <v-col cols="4" class="pa-1">
                                    <v-text-field-filled
                                        v-model.number="sumMinutes"
                                        :label="'Nombre total de minutes'"
                                        readonly
                                        :rules="[(v) => !!v || $t('settings.itemRequired')]"
                                        density="compact"
                                    />
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-window-item>
                    <v-window-item v-if="windowStep === 'table'" :value="'table'">
                        <v-row no-gutters>
                            <v-col cols="12" class="d-flex justify-end subtitle-2 pb-2">
                                Vos 100 dernières entrées
                            </v-col>
                            <v-col cols="12">
                                <v-virtual-scroll
                                    :item-height="60"
                                    :items="manualUserActivities"
                                    :height="
                                        manualUserActivities.length > 10
                                            ? '600px'
                                            : manualUserActivities.length * 60 + 'px'
                                    "
                                    class="py-3"
                                    bench="2"
                                >
                                    <template v-slot="{ item }">
                                        <v-list-item :key="item.id" class="oss-list-item mb-2">
                                            <v-row no-gutters>
                                                <v-col cols="4" class="d-flex align-center">
                                                    {{ item.company.name }}
                                                </v-col>
                                                <v-col
                                                    cols="3"
                                                    class="d-flex justify-center align-center"
                                                >
                                                    {{ formatDate(item.date) }}
                                                </v-col>
                                                <v-col
                                                    cols="3"
                                                    class="d-flex justify-center align-center"
                                                >
                                                    {{ formatDuration(item.duration) }}
                                                </v-col>
                                                <v-col
                                                    cols="2"
                                                    class="d-flex justify-center align-center"
                                                >
                                                    <v-btn-icon
                                                        icon="$delete "
                                                        color="error"
                                                        @click="deleteManualUserActivity(item.id)"
                                                        size="small"
                                                    />
                                                </v-col>
                                            </v-row>
                                        </v-list-item>
                                    </template>
                                </v-virtual-scroll>
                            </v-col>
                        </v-row>
                    </v-window-item>
                </v-window>
            </v-col>
        </v-row>

        <!-- </v-container>
        <v-card-actions>
            <v-row no-gutters class="pa-3">
                <v-col cols="12" class="d-flex justify-end">
                    <v-btn
                        rounded
                         size="small"
                        color="secondary"
                        elevation="0"
                        @click="valid()"
                    >
                        Valider
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-actions> -->
    </oss-dialog>
</template>

<script lang="ts">
import moment from "moment-timezone";

import ossCompanySelector from "../ossComponents/ossCompanySelector.vue";
import ossAccountingPeriodSelector from "../ossComponents/ossAccountingPeriodSelector.vue";

import { Apollo } from "@/decorators";

import CREATE_MANUAL_USER_ACTIVITY from "../../graphql/manualUserActivity/CreateManualUserActivity.gql";
import MANUAL_USER_ACTIVITY from "../../graphql/manualUserActivity/ManualUserActivitiesUser.gql";
import DELETE_MANUAL_USER_ACTIVITY from "../../graphql/manualUserActivity/DeleteManualUserActivity.gql";
import { getDBFormattedDate } from "@/services/dateServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Model } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

// import {checkFloat} from "../../services/mathServices"

@Component({
    components: {
        ossCompanySelector,
        ossAccountingPeriodSelector,
    },
})
export class UserWorkingTime extends Vue {
    @Model() value;

    valid = false;

    windowStep = "form";

    toggle = "form";

    company = {
        id: "",
    };

    date = "";

    loading: boolean = false;

    duration = {
        hours: 0,
        minutes: 0,
    };

    accountingPeriod = {
        id: "",
        start: "",
        end: "",
    };

    get selectedCompany() {
        return this.$store.state.selected_company;
    }

    get dialog() {
        return this.value;
    }

    set dialog(event) {
        this.value = event;
    }

    get allAvailableCompanies() {
        return this.$store.state.user.allAvailableCompanies;
    }

    get sumMinutes() {
        if (typeof this.duration.hours === "string") {
            return 0;
        }
        if (typeof this.duration.minutes === "string") {
            return 0;
        }
        // if (!checkFloat(this.duration.hours)) {
        //     return 0
        // }
        // if (!checkFloat(this.duration.minutes)) {
        //     return 0
        // }
        return 60 * this.duration.hours + this.duration.minutes;
    }

    get user() {
        return this.$store.state.user;
    }

    beforeMount() {
        this.updateSelectedCompany();
    }

    formatDuration = function formattingTheDurationOfAManualUserActivity(duration) {
        return Math.floor(duration / 60) + "h " + (duration % 60) + "min";
    };

    formatDate = function formattingThDate(date) {
        return moment(date).format("DD MMMM YYYY");
    };

    deleteManualUserActivity = async function deleteManualUserActivityLocalyandInDB(id) {
        this.manualUserActivities = this.manualUserActivities.filter((x) => x.id !== id);
        await this.$apollo.mutate({
            mutation: DELETE_MANUAL_USER_ACTIVITY,
            variables: {
                id: id,
            },
        });
    };

    get validDisabled() {
        if (!this.valid) return true;
        if (!this.date) return true;
        if (!this.company.id) return true;
        if (!this.accountingPeriod || !this.accountingPeriod.id) return true;
        // const mDate = moment(this.date)
        // if (moment(this.accountingPeriod.start).isAfter(mDate)) return true
        // if (moment(this.accountingPeriod.end).isBefore(mDate)) return true
        return false;
    }

    async createManualUserActivity() {
        // debugger;
        if (!this.validDisabled) {
            this.loading = true;
            await this.$apollo.mutate({
                mutation: CREATE_MANUAL_USER_ACTIVITY,
                variables: {
                    userId: this.user.id,
                    companyId: this.company.id,
                    date: getDBFormattedDate(this.date),
                    minutes: this.sumMinutes,
                    accountingPeriodId: this.accountingPeriod.id,
                },
            });
            this.company = { id: "" };
            this.date = "";
            this.duration = {
                hours: 0,
                minutes: 0,
            };
            this.accountingPeriod = {
                id: "",
                start: "",
                end: "",
            };
            this.dialog = false;
            this.loading = false;
        }
    }

    @Apollo({
        query: MANUAL_USER_ACTIVITY,
        variables() {
            return {
                id: this.user.id,
            };
        },
        skip() {
            return this.windowStep !== "table";
        },
    })
    manualUserActivities = [];

    @Watch("selectedCompany", { deep: true })
    updateSelectedCompany() {
        this.company = this.selectedCompany;
    }
}

export default toNative(UserWorkingTime);
</script>
